.rating-stars {
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 10px;
  width: fit-content;
  animation: fadeIn 0.1s ease-in-out forwards;
  animation-delay: 0.1s;
  opacity: 0;
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

.rating-stars-count {
  font-size: 13px;
  line-height: 18px;
}
